// extracted by mini-css-extract-plugin
module.exports = {"whiteBox":"ServiceCard_whiteBox__d1_Va","content":"ServiceCard_content__PfuEy","button":"ServiceCard_button__cR3ZW"};